import styled from '@emotion/styled';
import { BodyLarge, BodyMedium } from '../../styles';
import { shouldForwardProps } from '../../utils';

const UserInfoTitle = styled(BodyLarge, shouldForwardProps)`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const UserPronouns = styled(BodyLarge, shouldForwardProps)`
    color: ${({ theme }) => theme.colors.outline};
`;

const UserInfoSubtitle = styled(BodyMedium, shouldForwardProps)`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export { UserInfoTitle, UserPronouns, UserInfoSubtitle };
